import { Grid, Stack, Typography } from '@mui/material';

import { FProgressBar } from '../../../../components/base';
import { SelectionList } from '../../components';
import CulturalConsiderationField from './CulturalConsiderationField';
import { FAMILY_ADDITIONAL_INFO_CONFIGS } from '../constants';
import {
  FAMILY_ADD_BUTTON_SX,
  FAMILY_SECTION_HEADING_SX,
  FAMILY_SECTION_LABEL_SX,
} from '../styles';

import type { FamilyAdditionalInfoSectionProps } from './types';

export default function FamilyAdditionalInfoSection({
  additionalInfo,
  culturalConsideration,
  disabled,
  isSaving,
  hasSavedValues,
  showListErrors,
  onCreate,
  onDelete,
  onSaveCulturalConsideration,
  richTextCulturalConsideration = false,
}: FamilyAdditionalInfoSectionProps) {
  return (
    <Stack gap={3} textAlign="left">
      {isSaving ? <FProgressBar /> : null}
      <Typography variant="h6" sx={FAMILY_SECTION_HEADING_SX}>
        Family information
      </Typography>

      <Grid container spacing={2}>
        {FAMILY_ADDITIONAL_INFO_CONFIGS.map((config) => {
          const entries = additionalInfo[config.entriesKey];
          return (
            <Grid item xs={12} md={6} key={config.type}>
              <Typography variant="body1" sx={FAMILY_SECTION_LABEL_SX}>
                {config.heading}
              </Typography>
              <SelectionList
                addButtonLabel={config.addButtonLabel}
                addButtonSx={FAMILY_ADD_BUTTON_SX}
                disabled={disabled}
                entries={entries}
                error={showListErrors && hasSavedValues && entries.length === 0}
                getDeleteConfirm={(entry) => ({
                  title: `Confirm ${config.label.toLowerCase()} deletion?`,
                  message: `You are about to delete "${entry.value}"`,
                })}
                isSaving={isSaving}
                label={config.label}
                onAdd={(value) => onCreate(config.type, value)}
                onDelete={(id) => onDelete(config.type, id)}
                options={config.options}
                placeholder={config.placeholder}
                required
              />
            </Grid>
          );
        })}
        <Grid item xs={12} md={6}>
          <Typography variant="body1" sx={FAMILY_SECTION_LABEL_SX}>
            Spiritual or cultural considerations
          </Typography>
          <CulturalConsiderationField
            culturalConsideration={culturalConsideration}
            disabled={disabled}
            onSave={onSaveCulturalConsideration}
            richText={richTextCulturalConsideration}
          />
        </Grid>
      </Grid>
    </Stack>
  );
}
